import {
  SOCKET_CONNECTED_REALTIME_EVENTS,
  SOCKET_DISCONNECTED_REALTIME_EVENTS,
  SOCKET_EVENT_REALTIME_EVENTS,
} from 'actions/RealtimeEventActions';

const DEDUP_WINDOW_MS = 5000;

const initialState = {
  isConnected: false,
  subscribedRooms: [],
  lastEventsByKey: {},
  recentEvents: [],
};

function eventKey(event) {
  return `${event?.type}:${event?.scope?.entityId}`;
}

function isDuplicate(state, event) {
  const key = eventKey(event);
  const last = state.lastEventsByKey[key];
  if (!last) {
    return false;
  }
  if (last.id === event.id) {
    return true;
  }
  const occurredAt = new Date(event.occurredAt || 0).getTime();
  const lastAt = new Date(last.occurredAt || 0).getTime();
  return Math.abs(occurredAt - lastAt) < DEDUP_WINDOW_MS;
}

export default function realtimeEvents(state = initialState, action) {
  switch (action.type) {
    case SOCKET_CONNECTED_REALTIME_EVENTS:
      return { ...state, isConnected: true };

    case SOCKET_DISCONNECTED_REALTIME_EVENTS:
      return { ...state, isConnected: false };

    case SOCKET_EVENT_REALTIME_EVENTS: {
      const { event } = action.payload;
      if (!event?.type) {
        return state;
      }
      if (isDuplicate(state, event)) {
        return state;
      }
      const key = eventKey(event);
      return {
        ...state,
        lastEventsByKey: {
          ...state.lastEventsByKey,
          [key]: { id: event.id, occurredAt: event.occurredAt },
        },
        recentEvents: [event, ...state.recentEvents].slice(0, 50),
      };
    }

    default:
      return state;
  }
}
